export const InfoLine = ({ infoKey, value }) => (
  <div className="flex justify-between items-center my-1 h-8">
    <h5 className="text-dashboardtext text-sm font-hk ">{infoKey}</h5>
    <h5 className="text-dashboardtext text-sm font-hk bg-daresidepanelbg rounded-md py-1.5 px-2 ">
      {value}
    </h5>
  </div>
)
